<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #sidenav [mode]="isHandset ? 'over' : 'side'" [opened]="!isHandset" class="sidenav">
    <div class="sidenav-header">
      <mat-icon class="logo-icon">admin_panel_settings</mat-icon>
      <div class="logo-text">
        <span class="logo-title">Organizae</span>
        <span class="logo-subtitle">Administração</span>
      </div>
    </div>

    <mat-nav-list>
      @for (section of navSections; track section.label) {
        <div class="nav-section-label">{{ section.label }}</div>
        <div class="nav-group">
          @for (item of section.items; track item.route) {
            <a
              mat-list-item
              class="nav-item mb-1"
              [routerLink]="item.route"
              routerLinkActive="active-link"
              (click)="isHandset && sidenav.close()"
            >
              <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
              <span matListItemTitle>{{ item.label }}</span>
            </a>
          }
        </div>
      }
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content class="sidenav-content">
    <mat-toolbar class="toolbar">
      @if (isHandset) {
        <button mat-icon-button (click)="sidenav.toggle()">
          <mat-icon>menu</mat-icon>
        </button>
      }
      <span class="toolbar-title">Painel Administrativo</span>
      <span class="spacer"></span>
      <app-theme-toggle></app-theme-toggle>
      <button mat-icon-button [matMenuTriggerFor]="userMenu">
        <mat-icon>account_circle</mat-icon>
      </button>
      <mat-menu #userMenu="matMenu">
        @if (currentUserEmail) {
          <div class="menu-user-email">{{ currentUserEmail }}</div>
          <mat-divider></mat-divider>
        }
        <a mat-menu-item routerLink="/alterar-senha">
          <mat-icon>lock</mat-icon>
          <span>Alterar Senha</span>
        </a>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>Sair</span>
        </button>
      </mat-menu>
    </mat-toolbar>

    <div class="content-area">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
